'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApiReducer = exports.createApi = exports.createApiActions = exports.fetchMiddleware = exports.logMiddleware = exports.createAction = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.updateList = updateList;
exports.replaceListItems = replaceListItems;

var _compact = require('lodash/compact');

var _compact2 = _interopRequireDefault(_compact);

var _findIndex = require('lodash/findIndex');

var _findIndex2 = _interopRequireDefault(_findIndex);

var _reject = require('lodash/reject');

var _reject2 = _interopRequireDefault(_reject);

var _sortBy = require('lodash/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _types = require('./actions/types');

var _types2 = _interopRequireDefault(_types);

var _async = require('./async');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var joinPaths = function joinPaths() {
  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return ('/' + (0, _compact2.default)(paths).join('/')).replace(/\/+/g, '/');
};

// Returns a consistent `modified` key for a given object, used for cache look ups
var modifiedKey = function modifiedKey() {
  var merge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return ['modified'].concat((0, _sortBy2.default)(Object.entries(merge), 0).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    return key + '-' + val;
  })).join('-');
};

// Looks up a path (list of keys) in an object
var resolveState = function resolveState(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return path.reduce(function (obj, key) {
    return obj ? obj[key] : obj;
  }, state);
};

/**
 * Finds an item in the state and either replaces or updates it.
 * It then returns the new set of items which can be passed back to
 * a reducer.
 */
function updateList(state, id) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var merge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (data.length > 1) {
    return replaceListItems(state, id, data);
  } else {
    data = data[0];
  }

  var items = state.items;

  items = items.slice();

  // Insert unless id is a string or object
  if (!id || id === true) {
    items.push(data);
    return { items: items };
  }

  if (typeof id === 'string') {
    id = { id: id };
  }
  var index = (0, _findIndex2.default)(items, id);

  // Remove item if no data is provided
  if (data == null) {
    if (index !== -1) {
      items.splice(index, 1);
    }
  } else {
    var update = merge ? Object.assign({}, items[index], data) : data;
    var insert = Object.assign({}, id, update);
    index === -1 ? items.push(insert) : items.splice(index, 1, insert);
  }

  return { items: items };
}

function replaceListItems(state, id) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (typeof id === 'string') {
    id = { id: id };
  }

  return { items: (0, _reject2.default)(state.items, id).concat(data) };
}

var createAction = exports.createAction = function createAction(type) {
  for (var _len2 = arguments.length, argNames = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    argNames[_key2 - 1] = arguments[_key2];
  }

  // Register global type
  if (_types2.default[type]) {
    throw 'Action "' + type + '" is already registered';
  }

  _types2.default[type] = type;

  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var action = { type: type };
    argNames.forEach(function (name, i) {
      return action[name] = args[i];
    });

    return action;
  };
};

var logMiddleware = exports.logMiddleware = function logMiddleware() {
  return function (next) {
    return function (action) {
      console.log(action);
      return next(action);
    };
  };
};

var fetchMiddleware = exports.fetchMiddleware = function fetchMiddleware(_ref3) {
  var dispatch = _ref3.dispatch,
      getState = _ref3.getState;

  return function (next) {
    return function (action) {
      var type = action.type,
          merge = action.merge,
          append = action.append,
          cached = action.cached,
          isCached = action.isCached,
          request = action.request,
          _action$query = action.query,
          query = _action$query === undefined ? {} : _action$query;


      if (!request) {
        return next(action);
      }

      var state = getState();
      if (cached && isCached && isCached(state)) {
        return Promise.resolve();
      }

      dispatch({ type: type, query: query });

      return request(state).then(function (_ref4) {
        var resp = _ref4.response,
            body = _ref4.body;
        return dispatch({ type: type + '_SUCCESS', resp: resp, body: body, merge: merge, append: append, query: query });
      }).catch(function (err) {
        return err.response ? dispatch(Object.assign({
          type: type + '_ERROR',
          query: query
        }, err)) : dispatch({ type: type + '_ERROR', err: err, query: query });
      });
    };
  };
};

var createApiActions = function createApiActions(url, basePath, storePath, type) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  storePath = storePath || [basePath];
  type = (type || basePath).toUpperCase()

  // Register types
  ;[['GET', true], ['UPDATE', true], ['CREATE', true], ['DELETE', true], ['RESET', false]].forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        action = _ref6[0],
        async = _ref6[1];

    var name = action + '_' + type;
    _types2.default[name] = name;
    if (async) {
      _types2.default[name + '_SUCCESS'] = name + '_SUCCESS';
      _types2.default[name + '_ERROR'] = name + '_ERROR';
    }
  });

  // Support ability to manipulate all requests based on `state`
  var _options$mapStateToOp = options.mapStateToOptions,
      mapStateToOptions = _options$mapStateToOp === undefined ? function () {
    return {};
  } : _options$mapStateToOp;

  // We will take any values produced by the `mapStateToOptions` function to
  // be the "base" values. This means that values passed in directly to
  // actions dispatched will override the `mapStateToOptions` values. This is
  // basically an arbitrary decision but it seems reasonable to support
  // defining the base behavior in a single place (i.e. when invoking
  // helpers.createApiActions) and providing the ability to override in a one
  // off way.

  var mergeOptions = function mergeOptions(state, _ref7) {
    var headers = _ref7.headers,
        options = _objectWithoutProperties(_ref7, ['headers']);

    var _mapStateToOptions = mapStateToOptions(state),
        stateHeaders = _mapStateToOptions.headers,
        stateOptions = _objectWithoutProperties(_mapStateToOptions, ['headers']);

    return Object.assign({}, stateOptions, options, {
      headers: Object.assign({}, stateHeaders, headers)
    });
  };

  // Create actions
  return {
    get: function get() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          query = _ref8.query,
          path = _ref8.path,
          _ref8$options = _ref8.options,
          options = _ref8$options === undefined ? {} : _ref8$options,
          _ref8$cached = _ref8.cached,
          cached = _ref8$cached === undefined ? false : _ref8$cached,
          merge = _ref8.merge,
          append = _ref8.append;

      path = joinPaths(basePath, path);

      return {
        type: 'GET_' + type,
        path: path,
        query: query,
        merge: merge,
        append: append,
        cached: cached,
        isCached: function isCached(state) {
          return resolveState(state, storePath)[modifiedKey(merge)];
        },
        request: function request(state) {
          return (0, _async.makeRequest)({
            url: url,
            path: path,
            query: query,
            options: mergeOptions(state, options)
          });
        }
      };
    },
    create: function create() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          query = _ref9.query,
          path = _ref9.path,
          _ref9$options = _ref9.options,
          options = _ref9$options === undefined ? {} : _ref9$options;

      path = joinPaths(basePath, path);

      return {
        type: 'CREATE_' + type,
        path: path,
        query: query,
        request: function request(state) {
          return (0, _async.makeRequest)({
            url: url,
            path: path,
            query: query,
            options: mergeOptions(state, Object.assign({ method: 'POST' }, options))
          });
        }
      };
    },
    update: function update() {
      var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          query = _ref10.query,
          path = _ref10.path,
          merge = _ref10.merge,
          _ref10$options = _ref10.options,
          options = _ref10$options === undefined ? {} : _ref10$options;

      if (!merge) {
        throw 'You must specify a `merge` object for update operations';
      }

      path = joinPaths(basePath, path);

      return {
        type: 'UPDATE_' + type,
        path: path,
        query: query,
        merge: merge,
        request: function request(state) {
          return (0, _async.makeRequest)({
            url: url,
            path: path,
            query: query,
            options: mergeOptions(state, Object.assign({ method: 'PATCH' }, options))
          });
        }
      };
    },
    delete: function _delete() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          query = _ref11.query,
          path = _ref11.path,
          merge = _ref11.merge,
          _ref11$options = _ref11.options,
          options = _ref11$options === undefined ? {} : _ref11$options;

      if (!merge) {
        throw 'You must specify a `merge` object for delete operations';
      }

      if (!query) {
        throw 'You are trying to delete an entire table. If you are sure you want to do this, you must specify an empty `query: {}` option.';
      }

      path = joinPaths(basePath, path);

      return {
        type: 'DELETE_' + type,
        path: path,
        query: query,
        merge: merge,
        request: function request(state) {
          return (0, _async.makeRequest)({
            url: url,
            path: path,
            query: query,
            options: mergeOptions(state, Object.assign({ method: 'DELETE' }, options))
          });
        }
      };
    },
    reset: function reset() {
      return { type: 'RESET_' + type };
    }
  };
};

exports.createApiActions = createApiActions;
var createApi = exports.createApi = function createApi(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (basePath, storePath, type) {
    return createApiActions(url, basePath, storePath, type, options);
  };
};

var createApiReducer = exports.createApiReducer = function createApiReducer(path, type) {
  var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { items: [] };

  type = (type || path).toUpperCase();

  var success = type + '_SUCCESS';
  var error = type + '_ERROR';

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var modified = Date.now();
    var loading = false;
    var body = action.body,
        merge = action.merge,
        append = action.append;


    switch (action.type) {
      case 'GET_' + type:
      case 'CREATE_' + type:
      case 'UPDATE_' + type:
      case 'DELETE_' + type:
        return Object.assign({}, state, { loading: true });

      case 'GET_' + error:
      case 'UPDATE_' + error:
      case 'CREATE_' + error:
      case 'DELETE_' + error:
        return Object.assign({}, state, { loading: loading });

      case 'GET_' + success:
        if (merge || append) {
          return Object.assign({}, state, append ? {
            items: [].concat(_toConsumableArray(state.items), _toConsumableArray(body))
          } : updateList(state, merge, body), _defineProperty({
            loading: loading
          }, modifiedKey(merge), modified));
        } else {
          return { items: body, loading: loading, modified: modified };
        }

      case 'CREATE_' + success:
        return Object.assign({}, state, updateList(state, null, body), { loading: loading, modified: modified });

      case 'UPDATE_' + success:
        return Object.assign({}, state, updateList(state, merge, body, true), _defineProperty({
          loading: loading
        }, modifiedKey(merge), modified));

      case 'DELETE_' + success:
        return Object.assign({}, state, updateList(state, merge), _defineProperty({
          loading: loading
        }, modifiedKey(merge), modified));

      case 'RESET_' + type:
        return Object.assign({}, initialState);

      default:
        return state;
    }
  };
};